import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getCitationProofsOptions,
  useDeleteCitationProof,
  useUploadOrUpdateCitationProof,
} from './model/CitationProofModel';

interface CitationProofActionProps {
  citationId: number;
  authors: Author[];
  variant?: 'compact';
}

export function CitationProofAction({ citationId, authors }: CitationProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getCitationProofsOptions(citationId));
  const uploadOrUpdateMutation = useUploadOrUpdateCitationProof(citationId);
  const deleteMutation = useDeleteCitationProof(citationId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="citation"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
